module.exports = __webpack_public_path__ + "img/15.8a85bdc7.png";